<div class="bg-brand-bg dark:bg-dark mb-4">
    <!-- Header desktop -->
    <div *ngIf="!isMobileView()" class="flex items-center justify-between px-8 py-6">
        <!-- Título de la página -->
        <h1 class="text-4xl font-bold tracking-tight text-gray-900 dark:text-dark-text">
            <img src="assets/images/fina-full.webp" alt="{{ TEXT.HEADER.TITLE }}"
                class="h-10 w-auto dark:brightness-0 dark:invert">
        </h1>

        <!-- Sección central con filtro -->
        <div class="relative" #dropdownContainer>
            <button (click)="toggleDropdown()"
                class="flex items-center space-x-2 px-4 py-2 bg-white dark:bg-dark-tertiary dark:text-dark-text rounded-full shadow-sm hover:bg-gray-50 dark:hover:bg-opacity-80 transition-all duration-200 cursor-pointer">
                <span class="font-medium text-md text-gray-900 dark:text-dark-text">{{ selectedFilter }}</span>
                <span
                    class="material-symbols-rounded text-gray-500 dark:text-dark-text text-lg transition-transform duration-200"
                    [ngClass]="{'rotate-180': isDropdownOpen}">expand_more</span>
            </button>

            <!-- Dropdown Menu -->
            <div *ngIf="isDropdownOpen"
                class="absolute top-full -right-1/2 mt-2 w-52 bg-white/20 dark:bg-black/20 backdrop-blur-2xl border border-white/40 dark:border-white/10 rounded-[24px] shadow-soft overflow-hidden z-50 animate-fadeIn">
                <div *ngFor="let option of filterOptions" (click)="onFilterChange(option.value)"
                    class="px-4 py-3 cursor-pointer transition-colors duration-150 flex items-center justify-between hover:bg-black/5 dark:hover:bg-white/5"
                    [ngClass]="{
                        'bg-black/5 dark:bg-white/5': selectedFilter === option.label
                    }">
                    <span class="text-md font-medium text-gray-900 dark:text-dark-text">
                        {{ option.label }}
                    </span>
                    <span *ngIf="selectedFilter === option.label"
                        class="material-symbols-rounded text-gray-900 dark:text-brand-primary text-lg">
                        check
                    </span>
                </div>
            </div>
        </div>

        <!-- Sección derecha con notificaciones y perfil -->
        <div class="flex items-center space-x-4">
            <!-- Botón de notificaciones -->
            <div class="relative group">
                <button
                    class="relative p-2 text-gray-500 dark:text-dark-text hover:text-gray-700 dark:hover:text-white transition-colors">
                    <span class="material-symbols-rounded">notifications</span>
                    <span *ngIf="notificationsCount > 0"
                        class="absolute top-1 right-1 w-2 h-2 bg-danger rounded-full"></span>
                </button>
                <!-- Tooltip personalizado -->
                <div
                    class="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 px-2 py-1 bg-gray-700 bg-opacity-80 text-white text-xs rounded shadow-soft opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-50">
                    {{ TEXT.HEADER.SOON }}
                    <div
                        class="absolute bottom-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-3 border-r-3 border-b-3 border-transparent border-b-gray-700">
                    </div>
                </div>
            </div>

            <user-profile-menu></user-profile-menu>
        </div>
    </div>

    <!-- Header mobile -->
    <div *ngIf="isMobileView()" class="md:hidden w-vw px-4 mt-4">
        <div class="flex items-center justify-between mb-4 mt-10">
            <div class="flex items-center gap-2">
                <button *ngIf="!isStandalone()" (click)="toggleMobileMenu()"
                    class="p-2 -ml-2 text-gray-900 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-tertiary rounded-2xl transition-colors">
                    <span class="material-symbols-rounded">menu</span>
                </button>
                <h1 class="text-xl font-bold text-gray-900 dark:text-dark-text">
                    <img src="assets/images/fina-full.webp" alt="{{ TEXT.HEADER.TITLE }}"
                        class="h-8 w-auto dark:brightness-0 dark:invert">
                </h1>
            </div>
            <div class="flex items-center gap-3">
                <div class="relative group">
                    <button
                        class="relative p-2 hover:bg-gray-200 dark:hover:bg-dark-tertiary rounded-2xl dark:text-dark-text">
                        <span class="material-symbols-rounded">notifications</span>
                        <span *ngIf="notificationsCount > 0"
                            class="absolute top-1 right-1 w-2 h-2 bg-danger rounded-full"></span>
                    </button>
                    <!-- Tooltip personalizado -->
                    <div
                        class="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-2 bg-gray-800 text-white text-sm rounded-2xl shadow-soft opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-50">
                        {{ TEXT.HEADER.SOON_NOTIFICATIONS }}
                        <div
                            class="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-800">
                        </div>
                    </div>
                </div>
                <user-profile-menu></user-profile-menu>
            </div>
        </div>
    </div>

</div>